import { Mode, ValueType, HydratedFilter } from '@/filter/types';

const modeValueTypeMap: { [mode in Mode]: ValueType } = {
  hasany: 'id-list',
  hasall: 'id-list',
  is: 'id-list',
  hasnone: 'id-list',
  hasnothing: 'id-list',
  contains: 'text',
  notcontain: 'text',
};

export const valueTypeByMode = (mode: Mode): ValueType => modeValueTypeMap[mode];

export const valueTypeByFilter = (filter: HydratedFilter): ValueType => {
  const mode = filter.value.mode;
  const modeConfig = filter.allowedModes?.[mode];

  const baseValueType = modeValueTypeMap[mode];

  if (baseValueType === 'id-list' && modeConfig === 'singleSelect') {
    return 'id';
  }

  return baseValueType;
};
